import React from "react";
import RequestDetails from "../Requests/RequestDetails";

const IncompleteApplicationDetails = () => {
  return <RequestDetails />;
};

export default IncompleteApplicationDetails;
